import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { stagingProdApi } from "../../auth/authService";

// ================= LIST =================
export const fetchStagingProduction = createAsyncThunk(
    "stagingProduction/fetchStagingProduction",
    async (params, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.token;

            const res = await stagingProdApi(token, params);

            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Gagal mengambil data"
            );
        }
    }
);

// ================= DETAIL =================
export const fetchStagingProductionDetail = createAsyncThunk(
    "stagingProduction/fetchDetail",
    async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.token;

            //pastikan service support endpoint custom
            const res = await stagingProdApi(token, null, `/staging-production/${id}`);

            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Gagal mengambil detail"
            );
        }
    }
);

// ================= SUMMARY =================
export const selectStagingSummary = (state) => {
    const data = state.stagingProduction.data || [];

    const summary = {
        total: data.length,
        entriPaleting: 0,
        processBBM: 0,
        sudahBBM: 0,
        reject: 0,
    };

    data.forEach(item => {
        if (item.status === 0) summary.entriPaleting++;
        if (item.status === 1) summary.processBBM++;
        if (item.status === 2) summary.sudahBBM++;
        if (item.status === 3) summary.reject++;
    });

    return summary;
};

// ================= SLICE =================
const stagingProductionSlice = createSlice({
    name: "stagingProduction",
    initialState: {
        data: [],
        pagination: {},
        loading: false,
        error: null,

        // DETAIL
        detail: null,
        loadingDetail: false,
        errorDetail: null,
    },

    reducers: {
        clearDetail: (state) => {
            state.detail = null;
            state.errorDetail = null;
        },
    },

    extraReducers: (builder) => {
        builder
            // ================= LIST =================
            .addCase(fetchStagingProduction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStagingProduction.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
                state.pagination = action.payload;
            })
            .addCase(fetchStagingProduction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // ================= DETAIL =================
            .addCase(fetchStagingProductionDetail.pending, (state) => {
                state.loadingDetail = true;
                state.errorDetail = null;
            })
            .addCase(fetchStagingProductionDetail.fulfilled, (state, action) => {
                console.log(action);
                state.loadingDetail = false;
                state.detail = action.payload;
            })
            .addCase(fetchStagingProductionDetail.rejected, (state, action) => {
                state.loadingDetail = false;
                state.errorDetail = action.payload;
            });
    },
});

export const { clearDetail } = stagingProductionSlice.actions;

export default stagingProductionSlice.reducer;